// import { isEmptyObject } from "utilities/common";

import { isEmptyObject } from "utilities/common";


// export function productTraitValidation(fields, fullRoleTab) {
//     const errors = {};
//     if (!fields?.data?.[fullRoleTab]?.traitHeading) {
//         // Add error for the specific platform's mainTraitName
//         errors[fullRoleTab] = { 
//             traitHeading: "Trait Heading is required"
//         };
//     }
//     // Check for the specific platform data (e.g., hemp, hyperwolf, etc.)
//     if (!fields?.data?.[fullRoleTab]?.mainTraitName) {
//         // Add error for the specific platform's mainTraitName
//         errors[fullRoleTab] = { 
//             mainTraitName: "Trait name is required"
//         };
//     }
 
//     return { errors, isValid: isEmptyObject(errors) };
// }


export function productTraitValidation(fields, fullRoleTab) {
    const errors = {};
    
    if (!fields?.data?.[fullRoleTab]?.traitHeading) {
        // Initialize the object if it doesn't exist
        errors[fullRoleTab] = errors[fullRoleTab] || {};
        // Add error for traitHeading
        errors[fullRoleTab].traitHeading = "Trait Heading is required";
    }
    
    if (!fields?.data?.[fullRoleTab]?.mainTraitName) {
        // Initialize the object if it doesn't exist
        errors[fullRoleTab] = errors[fullRoleTab] || {};
        // Add error for mainTraitName
        errors[fullRoleTab].mainTraitName = "Trait name is required";
    }
    
    return { errors, isValid: isEmptyObject(errors) };
}